import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { ReservationService } from "../services/reservation-service/reservation.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";

import { LeadsService } from "../services/lead-service/lead-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../environments/environment";
import { ProjectsService } from "../services/projects/projects.service";
import { UserServiceService } from "../services/user-service/user-service.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
  selector: "app-payment-collection-view",
  templateUrl: "./payment-collection-view.component.html",
  styleUrls: ["./payment-collection-view.component.css"],
})
export class PaymentCollectionViewComponent implements OnInit {
  id;

  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));

  payment_collection: any;

  partially_methods = [
    "Visa",
    "Cash",
    "Transfer",
    "Cheque",
    "Cash instead of cheque",
  ];
  comment: string = "";
  comment_id: number = null;
  disableSubmitComment: boolean = false;

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService,
    private projectsService: ProjectsService,
    private leadsService: LeadsService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserServiceService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.route.params.subscribe(({ id }) => {
      if (!id) {
        this.router.navigate([".."]);
      }
      this.id = id;
      this.getPaymentCollection();
    });
  }

  getPaymentCollection() {
    this.slimLoadingBarService.start();
    this.reservationService
      .getSinglePaymentCollection(this.id)
      .subscribe(
        (res: any) => {
          this.payment_collection = res;

          this.payment_collection.collect_types = Array.from(
            new Set(this.payment_collection.receipts.map((r) => r.type_string))
          ).join(", ");
        },
        (err) => {
          this.router.navigate([".."]);
        }
      )
      .add(() => {
        this.slimLoadingBarService.complete();
      });
  }

  editComment(model) {
    this.disableSubmitComment = true;
    this.reservationService
      .editPaymentCollectionComment(this.comment_id, { comment: this.comment })
      .subscribe(
        (res) => {
          this.disableSubmitComment = false;
          model.close();
          this.getPaymentCollection();
        },
        (err) => {
          this.disableSubmitComment = false;
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  addComment(model) {
    this.disableSubmitComment = true;
    this.reservationService
      .addPaymentCollectionComment(this.id, { comment: this.comment })
      .subscribe(
        (res) => {
          this.disableSubmitComment = false;
          model.close();
          this.getPaymentCollection();
        },
        (err) => {
          this.disableSubmitComment = false;
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  deleteComment(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this comment!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.disableSubmitComment = true;
        this.reservationService
          .deletePaymentCollectionComment(id)
          .subscribe(
            (res) => {
              this.disableSubmitComment = false;
              this.getPaymentCollection();
            },
            (err) => {
              this.disableSubmitComment = false;
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "warning");
      }
    });
  }

  getComment(comment, id) {
    this.comment = comment;
    this.comment_id = id;
  }

  getDownloadUrl(imagePath): SafeUrl {
    const dataUrl = "data:image/jpeg;base64,";
    return this.sanitizer.bypassSecurityTrustUrl(dataUrl + imagePath);
  }
}



// WEBPACK FOOTER //
// ./src/app/payment-collection-view/payment-collection-view.component.ts